import { TUrlParameters } from '@ConfigLoader/Configs/ConnectionConfig';

function booleanFN(data: 'false' | 'true') {
    return data === 'true' ? true : false;
}

export default function paramToObject() {
    const urlParams = new URLSearchParams(window.location.search);
    const urlParamsObject: TUrlParameters = {};

    urlParams.forEach((value, key) => {
        switch (key) {
            case 'lang':
                urlParamsObject['languageCode'] = value;
                break;
            case 'isDemoPlay':
                urlParamsObject['isDemoPlay'] = value === 'true' || value === '1' ? true : false;
                break;
            case 'username':
                urlParamsObject['playerId'] = value;
                break;
            case 'game':
                urlParamsObject['gameId'] = value;
                break;
            case 'casino':
                urlParamsObject['casinoId'] = value;
                break;
            case 'language':
                urlParamsObject['languageCode'] = value;
                break;
            case 'token':
                urlParamsObject['casinoTempToken'] = value;
                break;
            case 'real':
                // RGS
                if (value === '0' || value === '1') {
                    urlParamsObject['isDemoPlay'] = value === '0' ? true : false;
                }

                // GAME PRO - SYNOT TECH
                if (value === 'true' || value === 'false') {
                    urlParamsObject['isDemoPlay'] = value === 'false' ? true : false;
                }
                break;

            case 'cashierUrl':
                urlParamsObject['cashierUrl'] = value;
                break;
            case 'backUrl':
                urlParamsObject['homeUrl'] = value;
                break;
            case 'clientplatform':
                urlParamsObject['clientPlatform'] = value;
                break;
            case 'clienttype':
                urlParamsObject['clientType'] = value;
                break;

            /*Kaizen Gaming Integration*/
            case 'LaunchToken':
                urlParamsObject['casinoTempToken'] = value;
                break;
            case 'GameCode':
                urlParamsObject['gameId'] = value;
                break;
            case 'PlayerId':
                urlParamsObject['playerId'] = value;
                break;
            case 'Locale':
                const lang = value.split('-');
                urlParamsObject['languageCode'] = lang[0];
                urlParamsObject['countryCode'] = lang[1];
                break;
            case 'IsTestPlayer':
                urlParamsObject['isInternalPlayer'] = value === 'true' ? true : false;
                break;
            case 'PlayMode':
                urlParamsObject['isDemoPlay'] = value === 'cash' ? false : true;
                break;
            case 'HomeUrl':
                urlParamsObject['homeUrl'] = value;
                break;
            case 'DepositUrl':
                urlParamsObject['cashierUrl'] = value;
                break;
            case 'Platform':
                urlParamsObject['clientPlatform'] = value;
                break;

            /*SynotTech Gaming Integration*/
            case 'lobbyUrl':
                urlParamsObject['homeUrl'] = value;
                break;

            /* The Codium iNTEGRATION */
            case 'player':
                urlParamsObject['playerId'] = value;
                break;
            case 'mode':
                urlParamsObject['isDemoPlay'] = value === 'Demo' ? true : false;
                break;
            case 'home':
                urlParamsObject['homeUrl'] = value;
                break;
            case 'platform':
                if (value === 'w') urlParamsObject['clientPlatform'] = 'web';
                if (value === 'a' || value === 'i') urlParamsObject['clientPlatform'] = 'mobile';
                break;

            default:
                urlParamsObject[key] = value;
                break;
        }
    });
    return urlParamsObject;
}
